import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby-theme-material-ui';
import styles from './styles/reviewStyles';
import ShortsVideo from '../ShortsVideo/ShortsVideo';

const createSotialLogo = (link) => {
  const { source } = link;
  switch (source) {
    case 'telegram': {
      return <StaticImage src="./images/telegram.png" alt="telegram-logo" />;
    }
    case 'github': {
      return <StaticImage src="./images/git.png" alt="gihub-logo" />;
    }
    case 'habr': {
      return <StaticImage src="./images/habr.png" alt="habr-logo" />;
    }
  }
};

function VideoReviewCard({
  video,
  image,
  fullName,
  company,
  position,
  content,
  links,
  onlyVideo,
  ratio,
  ...props
}) {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);
  return (
    <Box sx={{ ...styles.card, ...props }}>
      <Box sx={styles.personalInfoBlock(onlyVideo)}>
        <Box sx={styles.video}>
          {loaded && (
            <ShortsVideo video={video}>
              <GatsbyImage
                image={getImage(image)}
                alt={fullName || 'preview'}
                loading="lazy"
              />
            </ShortsVideo>
          )}
        </Box>
        {!onlyVideo && (
          <Box sx={styles.personalInfo}>
            <Typography variant="desktopH4" sx={styles.name}>
              {fullName}
            </Typography>
            <Typography variant="desktopP2" sx={styles.position}>
              {position}
            </Typography>
          </Box>
        )}
      </Box>
      {!onlyVideo && (
        <Box sx={{ ...styles.opinion }}>
          {!!links && (
            <Box sx={styles.links}>
              {links.map((item) => (
                <Link
                  key={`${video}-${item.source}`}
                  variant={'kitSecondary'}
                  to={item.url}
                  target="_blank"
                  sx={styles.socialLink}
                >
                  <Box sx={styles.social}>{createSotialLogo(item)}</Box>
                  Спросить про обучение
                </Link>
              ))}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}

export default VideoReviewCard;
